import { apiGroup } from '../http';

var _apiGroup = apiGroup({
  name: 'BridgeModelQualification',
  dataOption: 'bridgeModelQualification',
  plural: {
    requiredOptions: ['modelName'],
    url: function url(_ref) {
      var modelName = _ref.modelName;
      return "/models/".concat(modelName, "/qualifications");
    },
    transform: function transform(response) {
      return {
        bridgeModelQualifications: response.data.qualifications
      };
    }
  },
  singular: {
    requiredOptions: ['modelName', 'qualificationName'],
    url: function url(_ref2) {
      var modelName = _ref2.modelName,
          qualificationName = _ref2.qualificationName;
      return "/models/".concat(modelName, "/qualifications/").concat(qualificationName);
    },
    transform: function transform(response) {
      return {
        bridgeModelQualification: response.data.qualification
      };
    }
  }
}),
    fetchBridgeModelQualifications = _apiGroup.fetchBridgeModelQualifications,
    fetchBridgeModelQualification = _apiGroup.fetchBridgeModelQualification,
    createBridgeModelQualification = _apiGroup.createBridgeModelQualification,
    updateBridgeModelQualification = _apiGroup.updateBridgeModelQualification,
    deleteBridgeModelQualification = _apiGroup.deleteBridgeModelQualification;

export { fetchBridgeModelQualifications, fetchBridgeModelQualification, createBridgeModelQualification, updateBridgeModelQualification, deleteBridgeModelQualification };